import {useQuery} from "react-query";
import apis from "services";
import {useSelector} from "react-redux";
import {get} from "lodash";

export default function useFetchMemberOptions() {

    const {memberDialog} = useSelector(state => state.inbox)

    const {data: optionResponse} = useQuery('member_options', apis.memberOptionsApi, {enabled: memberDialog});

    const memberOptions = get(optionResponse, 'data', null);

    return [memberOptions]
}